import { AlertTriangle } from 'lucide-react'
import { getHttpErrorMessage, getHttpStatus } from '@/lib/httpErrors'

/** Error amigable — nunca traza técnica, SQL, URL interna ni nombre de excepción.
 * Si se pasa `error` (el objeto de error de la consulta) y no se pasa `body` explícito,
 * el mensaje se deriva del status HTTP real (401/403/404/409/429/500/502/503/504) en vez
 * del texto genérico por defecto. */
export function ErrorState({
  title = 'No fue posible actualizar los datos',
  body,
  error,
  onRetry,
}: {
  title?: string
  body?: string
  error?: unknown
  onRetry?: () => void
}) {
  const resolvedBody =
    body ?? (error !== undefined ? getHttpErrorMessage(getHttpStatus(error)) : 'El servidor no respondió. Inténtalo nuevamente.')
  return (
    <div className="card text-center py-8 space-y-3">
      <AlertTriangle className="h-7 w-7 mx-auto text-warn" />
      <div>
        <p className="text-sm font-medium text-text">{title}</p>
        <p className="text-xs text-text-muted mt-1">{resolvedBody}</p>
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-4 py-1.5 rounded-lg bg-accent text-white text-xs font-medium"
        >
          Reintentar
        </button>
      )}
    </div>
  )
}
